/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Documents_Upload_CategoryInputs */

const cs_documents_upload_category = /** @type {(inputs: Documents_Upload_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kategorie nahrání`)
};

const en_documents_upload_category = /** @type {(inputs: Documents_Upload_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload category`)
};

/**
* | output |
* | --- |
* | "Upload category" |
*
* @param {Documents_Upload_CategoryInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_upload_category = /** @type {((inputs?: Documents_Upload_CategoryInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Upload_CategoryInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_documents_upload_category(inputs)
	return cs_documents_upload_category(inputs)
});